import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';  // Importa SweetAlert2
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import "./CSS/styles.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { faHandshakeAlt } from '@fortawesome/free-solid-svg-icons';

import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import MenuDesplegable from './JS/MenuDesplegable';
import axios from 'axios'; // Importa axios
import Loading from '../../Loading';
import { dominio } from "../../../routes_backend/routes.jsx";


const myGrid = React.createRef();
const myGrid2 = React.createRef();
const myGrid3 = React.createRef();
const myGrid4 = React.createRef();

class Entrega extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      isModalOpenLote: false,
      isModalOpenSociosNegocios: false,
      selectedRows: [], 
      opcionSel: '',
      selectedOption: '', 
      sourceGridCodigos:"",
      sourceGridCodigosLotes:"",
      sourceGridCodigosSociosNegocios:"",
      columns: [
                // { text: "", columntype: 'button', width: 80, cellsrenderer: () => 'Buscar', 
                //   buttonclick: (row) => { const dataRecord = myGrid.current.getrowdata(row); var codigoBuscar; codigoBuscar = dataRecord.codigoCliente; this.abrirModal(codigoBuscar); }, editable: false },      
                // { text: "Codigo", datafield: "codigo", width: 100, editable: false },
                // { text: "Descripcion de Articulo", datafield: "descripcionArticulo", width: 300, editable: false },
                { text: "Codigo Ffacsa", datafield: "codigoCliente", width: "15%", editable: false },
                { text: "Descripcion", datafield: "descripcion", width: "70%", editable: false },
                { text: "Cantidad", datafield: "cantidad", width: "11%", editable: false },
                // { text: "Stock", datafield: "stock", width: 100, editable: false },
                // { text: "Bodega", datafield: "bodega", width: 100, editable: false },
                // { text: "Almacen Destino", datafield: "almacenDestino", width: 100, editable: false },
                // { text: "Localidad", datafield: "localidad", width: 100, editable: false },
                // { text: "Centro de Costo", datafield: "centroCosto", width: 100, editable: false },
                // { text: "Departamento", datafield: "departamento", width: 100, editable: false },
               ],

    columnsCodigos: [
                      { text: "", columntype: 'button', width: 80, cellsrenderer: () => 'Buscar', 
                        buttonclick: (row) => { const dataRecord = myGrid2.current.getrowdata(row); 
                          var codigoBuscarLote; codigoBuscarLote = dataRecord.U_CodMacizo; 
                          var codigoBuscarAlmacen; codigoBuscarAlmacen = dataRecord.WhsCode; 
                          this.abrirModalLote(codigoBuscarLote, codigoBuscarAlmacen); }, editable: false 
                      },
                      { text: "U_CodMacizo", datafield: "U_CodMacizo", width: 100 },
                      { text: "U_DesMacizo", datafield: "U_DesMacizo", width: 300 },
                      { text: "U_CodCliente", datafield: "U_CodCliente", width: 100 },
                      { text: "WhsCode", datafield: "WhsCode", width: 80 },
                      { text: "U_Planta", datafield: "U_Planta", width: 80 },
                    ],

    columnsCodigosLotes: [
                      { text: "", columntype: 'button', width: 80, cellsrenderer: () => 'Buscar', editable: false, 
                        buttonclick: (row) => { 
                          const dataRecord = myGrid3.current.getrowdata(row); 
                          var codigoSeleccionadoWhsCode; codigoSeleccionadoWhsCode = dataRecord.WhsCode; 
                          var codigoSeleccionadoWhslote; codigoSeleccionadoWhslote = dataRecord.lote; 
                          var codigoSeleccionadoWhsQuantity; codigoSeleccionadoWhsQuantity = dataRecord.Quantity; 
                          this.LoteSeleccionado(codigoSeleccionadoWhsCode, codigoSeleccionadoWhslote, codigoSeleccionadoWhsQuantity); 
                        }                          
                      },
                      { text: "ItemCode", datafield: "ItemCode", width: 130, editable: false },
                      { text: "lote", datafield: "lote", width: 150, editable: false },
                      { text: "WhsCode", datafield: "WhsCode", width: 80, editable: false },
                      { text: "Quantity", datafield: "Quantity", width: 150, editable: true },
                    ],

    columnsCodigosSociosNegocios: [
                      { text: "", columntype: 'button', width: 80, cellsrenderer: () => 'Buscar', editable: false, 
                        buttonclick: (row) => { 
                          const dataRecord = myGrid4.current.getrowdata(row); 
                          var codigoSeleccionadoCardCode; codigoSeleccionadoCardCode = dataRecord.CardCode; 
                          var codigoSeleccionadoCardName; codigoSeleccionadoCardName = dataRecord.CardName; 
                          // var codigoSeleccionadoWhsQuantity; codigoSeleccionadoWhsQuantity = dataRecord.Quantity; 
                          this.SocioNegociosSeleccionado(codigoSeleccionadoCardCode, codigoSeleccionadoCardName); 
                        }                          
                      },
                      { text: "CardCode", datafield: "CardCode", width: "15%", editable: false },
                      { text: "CardName", datafield: "CardName", width: "70%", editable: false },
                     ],
    
    sourceGridMacizo: new jqx.dataAdapter({
        localData: [], 
        dataType: "json",
    }),


    numRows: 0,

      numeroFactura: "",
      CardCode: "",
      U_FacNomE: "",
      U_FacNITE: "",
      CardName: '',
      sociosNegocios: [],
      Comments: "",
      showAlert: false,
      docNum: '',
      DocDate: new Date(),
      DocumentLines: [
        {
          ItemCode: "",
          Quantity: "",
          TaxCode: "",
          Price: "",
          PriceAfterVAT: "",
          WarehouseCode: "",
          BatchNumbers: [
            {
              BatchNumber: "",
              Quantity: "",
            },
          ],
        },
      ],

      
    };


    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleRowSelect = this.handleRowSelect.bind(this);

    this.abrirModal = this.abrirModal.bind(this);
    this.cerrarModal = this.cerrarModal.bind(this);

    this.abrirModalLote = this.abrirModalLote.bind(this);
    this.cerrarModalLote = this.cerrarModalLote.bind(this);


  }


  render() {

    const { isLoading, numeroFactura, CardCode, U_FacNomE, U_FacNITE, CardName, Comments, docNum, DocDate, DocumentLines, } = this.state;
    
    const filteredState = { numeroFactura, CardCode, U_FacNomE, U_FacNITE, CardName, Comments, docNum, DocDate, DocumentLines, };

    const showAlertComponent = this.state.showAlert ? (
      <Alert variant="success" className="text-center"> <strong>Entrega realizada exitosamente.</strong><br /> Numero de Documento: {this.state.docNum} </Alert>
    ) : null;
    const showAlertComponentErrorCardCode = this.state.showAlert ? (
      <Alert variant="error" className="text-center"> <strong>Seleccione CardCode.</strong><br /> </Alert>
    ) : null;



    return (

      <div>
        {/* <link rel="stylesheet"></link> */}

        <h3>Entrega</h3>
        <div>
          {showAlertComponent}
        </div>
        <div>
          {showAlertComponentErrorCardCode}
        </div>

        
        <form className='formStyle' >
          <div style={{ display: 'flex', /* justifyContent: 'space-between'*/ }}>

            {/* --------- Primer div ----------  */}
            <div>
              <label className='labelStyle'> Card Code: <br />
              <FontAwesomeIcon
            icon={faHandshakeAlt}
            style={{ marginLeft: '5px', color: 'black', cursor: 'pointer' }}
            onClick={this.abrirModalSociosNegocios}
          />

                <select className="customInputCardCode"
                
                  name="CardCode" value={this.state.CardCode} onChange={this.handleInputChangeCardName}  disabled={this.state.opcionSel === 'Copiar de Fact. Cliente'}>
                  <option value="" disabled hidden> Seleccione.. </option> 
                  {this.state.sociosNegocios.map((socio) => ( <option key={socio.CardCode} value={socio.CardCode}> {socio.CardCode} </option> ))}
                  
                </select>

              </label>

              <label className='labelStyle'> Nombre: <br />
                <input className="customInputNombre"
                  type="text" value={this.state.CardName}  readOnly />
              </label>

              <label className='labelStyle'> Tienda / Cliente: <br />
              <select className="customTiendaCliente"
                  value={this.state.selectedOptionTienda} onChange={this.handleSelectChangeTienda} >
                  <option value="none.">Seleccione...</option> <option value="FFACSA #1">FFACSA #1</option> <option value="FFACSA #2">FFACSA #2</option> <option value="FFACSA #3">FFACSA #3</option>
                </select>
              </label>

              <label className='labelStyle'> Entrega a Cliente: <br />
                <input  className="customInput2"
                  type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> Referencia: <br />
              <input className="customInput2"
                  type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> No. de Salida: <br />
              <input className="customInput2"
                  type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>
              <br />

              <label className='labelStyle'> &nbsp;&nbsp; Doc Date: <br />
                <div style={{ position: 'relative' }}>
                  <DatePicker selected={this.state.DocDate} onChange={this.handleDateChange} dateFormat="yyyy-MM-dd" className="customDatePicker" />
                  <FontAwesomeIcon icon={faCalendar} className="customCalendar" />
                </div>
              </label>

              <label className='labelStyle'> &nbsp;&nbsp; F. Documento: <br />
                <div style={{ position: 'relative' }}>
                  <DatePicker selected={this.state.DocDate} onChange={this.handleDateChange} dateFormat="yyyy-MM-dd" className="customDatePicker"  />
                  <FontAwesomeIcon icon={faCalendar} className="customCalendar" />
                </div>
              </label>

              <label className='labelStyle'> &nbsp;&nbsp; F. Contabilizacion: <br />
                <div style={{ position: 'relative' }}>
                  <DatePicker selected={this.state.DocDate} onChange={this.handleDateChange} dateFormat="yyyy-MM-dd" className="customDatePicker" />
                  <FontAwesomeIcon icon={faCalendar} className="customCalendar" />
                </div>
              </label>

              <label className='labelStyle'> Departamento: <br />
               <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> Municipio: <br />
              <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>
              <br />
              <br />

              <label className='labelStyle'> Nit Cliente: <br />
                <input className="customInput" type="text" name="U_FacNITE" value={this.state.U_FacNITE} onChange={this.handleInputChange}  disabled={this.state.opcionSel === 'Copiar de Fact. Cliente'}/>

              </label>

              <label className='labelStyle'> Nombre Cliente: <br /> 
              <input className="customInputNombreCliente" type="text" name="U_FacNomE" value={this.state.U_FacNomE} onChange={this.handleInputChange}  disabled={this.state.opcionSel === 'Copiar de Fact. Cliente'}/>
              </label>
              &nbsp;&nbsp;

              <label className='labelStyle'>
                <input type="radio" name="option" value="factura" checked={this.state.selectedOption === 'factura'} onChange={this.handleRadioChange}  disabled={this.state.opcionSel === 'Copiar de Fact. Cliente'}/>
                &nbsp;&nbsp;&nbsp;&nbsp; Factura
              </label>

              <label className='labelStyle'>
                <input type="radio" name="option" value="traslado" checked={this.state.selectedOption === 'traslado'} onChange={this.handleRadioChange}  disabled={this.state.opcionSel === 'Copiar de Fact. Cliente'}/>
                &nbsp;&nbsp;&nbsp;&nbsp; Traslado
              </label>

              <label className='labelStyle'>
                <input type="radio" name="option" value="reposicion" checked={this.state.selectedOption === 'reposicion'} onChange={this.handleRadioChange}  disabled={this.state.opcionSel === 'Copiar de Fact. Cliente'}/>
                &nbsp;&nbsp;&nbsp;&nbsp; Reposición
              </label>

              <label className='labelStyle'>
                <input type="radio" name="option" value="oc" checked={this.state.selectedOption === 'oc'} onChange={this.handleRadioChange}  disabled={this.state.opcionSel === 'Copiar de Fact. Cliente'}/>
                &nbsp;&nbsp;&nbsp;&nbsp; OC
              </label>
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            {/* --------- segundo div ----------  */}
            <div>
              <label className='labelStyle'> Turno: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> Area Solicita: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> Serie: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> Codigo Documento: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>
              <br /> 

              <label className='labelStyle'> Horometro Inicial: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> Horometro Final: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> Vehiculo: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>

              <label className='labelStyle'> Piloto: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label>
              <br />

              <label className='labelStyle'> Tipo de Flete: <br />
                <input className="customInput" type="text"
                // name="CardCode"
                // value={this.state.CardCode}
                // onChange={this.handleInputChange}
                />
              </label> <br /> <br /> <br />

              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div>
                
                
                  <label className='labelStyle'> No Factura: <br />
                  
                  {/* {console.log(this.state.opcionSel)} */}
                  <input className="customInput" type="text" name="numeroFactura" value={this.state.numeroFactura} onChange={this.handleInputChange} disabled={this.state.opcionSel === 'Copiar de Fact. Cliente'} />
                  </label>
                  {this.state.opcionSel !== 'Copiar de Fact. Cliente' &&
                    <MenuDesplegable 
                      opciones={this.state.opcionSel !== 'OTRO' ? ['Copiar de Fact. Cliente', 'OTRO'] : ['Copiar de Fact. Cliente']} 
                      onOpcionSeleccionada={this.handleOpcionMenu} 
                    />
                  }

                </div>
              </div>

            </div>
            
          </div>

          <div className="modal" tabIndex="-1" role="dialog" style={{ display: this.state.isModalOpen ? 'block' : 'none' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Codigos</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.cerrarModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {/* Coloca aquí el código del grid */}
                <JqxGrid
                  ref={myGrid2}
                  theme={"material"}
                  width={"100%"}
                  height={300}
                  columns={this.state.columnsCodigos}
                  source={this.state.sourceGridCodigos}
                  altrows={true}
                  columnsresize={true}
                  // selectionmode={'checkbox'}
                  onRowselect={this.handleRowSelect}
                  // editable={true}
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={this.cerrarModal}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>   

        {/* -------------- */}

        <div className="modal" tabIndex="-1" role="dialog" style={{ display: this.state.isModalOpenLote ? 'block' : 'none' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title"> Lotes</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.cerrarModalLote}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <JqxGrid
                  ref={myGrid3}
                  theme={"material"}
                  width={"100%"}
                  height={300}
                  columns={this.state.columnsCodigosLotes}
                  source={this.state.sourceGridCodigosLotes}
                  altrows={true}
                  columnsresize={true}
                  // selectionmode={'checkbox'}
                  onRowselect={this.handleRowSelect}
                  editable={true}
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={this.cerrarModalLote}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>  

        <div className="modal" tabIndex="-1" role="dialog" style={{ display: this.state.isModalOpenSociosNegocios ? 'block' : 'none' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title"> Socios de Negocios</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.cerrarModalSociosNegocios}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <JqxGrid
                  ref={myGrid4}
                  theme={"material"}
                  width={"100%"}
                  height={300}
                  columns={this.state.columnsCodigosSociosNegocios}
                  source={this.state.sourceGridCodigosSociosNegocios}
                  altrows={true}
                  columnsresize={true}
                  // selectionmode={'checkbox'}
                  onRowselect={this.handleRowSelect}
                  // editable={true}
                  // filterable={true}
                  // showfilterrow={true}


                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={this.cerrarModalSociosNegocios}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div> 


        {/* ---------- GRID ------------ */}
        <div className="row">
        <p style={{ color: "red", textAlign: "center", fontSize: "20px" }}>
            <strong>Facturas Ffacsa</strong>
          </p>
          <div style={{ width: '58%', margin: '0 auto' }}>
            <button type="button" onClick={this.handleEliminarFilas}>Eliminar</button>
          </div>
          <div className="col-sm-12" style={{ textAlign: 'center' }}>
            
            <div style={{ width: '60%', margin: '0 auto' }}>
              <JqxGrid
                ref={myGrid}
                theme={"material"}
                width={"100%"}
                columns={this.state.columns}
                source={this.state.sourceGridMacizo}
                altrows={true}
                columnsresize={true}
                selectionmode={'checkbox'}
                onRowselect={this.handleRowSelect}
                editable={true}
                onCellendedit={(event) => this.handleGridCellEndEdit(event)}
                autoheight={true}
              />
            </div>
          </div>
        </div>

        <br />
          <br />
        {/* ---------- GRID ------------ */}

        <p style={{ color: "red", textAlign: "left", fontSize: "20px" }}>
            <strong>Entrega MACIZO</strong>
          </p>
          {/* <button type="button" onClick={this.addDocumentLine}>
            Agregar Linea
          </button> */}
        

        {this.state.DocumentLines.map((line, index) => (
          <div key={index} className='documentLineContainerStyle'>
            <button type="button" onClick={() => this.abrirModal(line.ItemCodeFfacsa)} className="customButtonLMac">Buscar</button>
            &nbsp;&nbsp;

            <label className='labelStyle'> Codigo: <br /> 
              <input type="text" name="ItemCode" value={line.ItemCode} onChange={(event) => this.handleInputChangeOtro(event, index)} className="customInputMacizo"
                      disabled={this.state.searchButtonClicked} 

              />
            </label>             
            <label className='labelStyle'> Cantidad: <br />
              <input type="text" name="Quantity" value={line.Quantity} onChange={(event) => this.handleInputChange(event, index)} className="customInputMacizo" disabled={this.state.searchButtonClicked} />
            </label>
                      
            <label className='labelStyle'> Almacen: <br />
              <input type="text" name="WarehouseCode" value={line.WarehouseCode} onChange={(event) => this.handleInputChangeOtro(event, index)} className="customInputMacizo" disabled={this.state.searchButtonClicked}  />
            </label>
            <div className='batchNumberContainerStyle'>
              {line.BatchNumbers.map((batch, batchIndex) => (
                <div key={batchIndex}>
                  <label className='labelStyle'> Lote: <br />
                    <input type="text" name="BatchNumber" value={batch.BatchNumber} onChange={(event) => this.handleBatchNumberChange(event, index, batchIndex)} className="customInputMacizo" disabled={this.state.searchButtonClicked}
                    />
                  </label>
                  {/* &nbsp;&nbsp; */}
                  <label className='labelStyle'> Cantidad Lote: <br />
                    <input name="Quantity" value={batch.Quantity} onChange={(event) => this.handleBatchNumberChange(event, index, batchIndex)} className="customInputMacizo" disabled={this.state.searchButtonClicked} 
                    />
                  </label> 
                  <br />
                </div>
              ))}
            </div>
          </div>
        ))}
          <div className="col-sm-12">
            <br />

            <div className='divText'>
              <label className='labelStyle'> Comments: </label>
              <textarea className='customTextarea'  type="text" name="Comments" value={this.state.Comments} onChange={this.handleInputChangeComentario} />
            </div>
            <br />
          </div>
          {/* <button type="submit">Submit</button> */}
          <button type="button" onClick={this.handleCrear}>Crear</button>
        </form>

        <br />
        <br />
        {/* <pre>{JSON.stringify(this.state, null, 2)}</pre> */}
      <pre>{JSON.stringify(filteredState, null, 2)}</pre>;
      {isLoading && <Loading />}
      </div>
      
    );
    
    
  }


 



// componentWillUnmount() {
//   if (this.state.inactivityTimeout) {
//     clearTimeout(this.state.inactivityTimeout);
//   }
//   window.removeEventListener('mousemove', this.handleUserActivity);
//   window.removeEventListener('keypress', this.handleUserActivity);
// }


handleGridCellEndEdit(event) {
  const { rowindex, value } = event.args;

  this.setState(prevState => {
    const updatedDocumentLines = [...prevState.DocumentLines];
    updatedDocumentLines[rowindex] = {
      ...updatedDocumentLines[rowindex],
      ItemCode: value,
      Quantity: value,
    };

    // console.log('Updated DocumentLines:', updatedDocumentLines);

    return {
      DocumentLines: updatedDocumentLines,
    };
  });
}

  copiarDeFacturaCliente = () => {
    if (this.state.CardCode === "" || this.state.numeroFactura === "") {
      const errorMessage = "";
      Swal.fire({
        icon: 'error',
        title: 'Seleccione CardCode o Ingrese numero de Factura',
        text: errorMessage || 'Verifique los campos requeridos'
      }).then(() => {
        window.location.reload();
      });
      return;
    }
  
    if (this.state.selectedOption === 'Copiar de Fact. Cliente') {
      this.setState({
        selectedOption: 'factura',
      });
    }
  
    const apiUrl = `http://portal.ffacsa.com/API/ffacsaAppsMacizo/SAPData/Factura?docNum=${this.state.numeroFactura}`;
    const apiKey = '1C94E299-5339-4C01-B95E-D2D6023FE7E9';
  
    axios.get(apiUrl, {
      headers: {
        'APIKey': apiKey,
      },
    })
    .then((response) => {
      const facturaData = response.data;
  
      this.setState({
        U_FacNomE: facturaData.U_FacNom,
        U_FactNom: facturaData.U_FactNom,
        U_FacNITE: facturaData.U_FacNIT,
        detailData: facturaData.Detail,
      });
  
      const gridData = facturaData.Detail.map((detail) => ({
        codigoCliente: detail.ItemCode,
        descripcion: detail.Dscription,
        cantidad: detail.Quantity,
      }));
  
      const updatedData = [...this.state.sourceGridMacizo.records, ...gridData];
      const uniqueData = Array.from(new Set(updatedData.map(JSON.stringify))).map(JSON.parse);
  
   
  
      this.setState({
        sourceGridMacizo: new jqx.dataAdapter({
          localData: uniqueData,
          dataType: "json",
        }),
      });
  
      const documentLines = [];
      // console.log(gridData);

      
      for (let i = 0; i < gridData.length; i++) {
        documentLines.push({
          ItemCodeFfacsa: gridData[i].codigoCliente,
          ItemCode: "",
          Quantity: gridData[i].cantidad,
          TaxCode: "",
          Price: "",
          PriceAfterVAT: "",
          WarehouseCode: "",
          BatchNumbers: [
            {
              BatchNumber: "",
              Quantity: "",
            },
          ],
        });
      }
  
      this.setState({
        DocumentLines: documentLines,
      });

 
      
  
      // console.log('Datos de factura y detalles:', facturaData);
    })
    .catch((error) => {
      const errorMessage = error
  
      Swal.fire({
        icon: 'error',
        title: 'Numero de factura no encontrada',
        text: errorMessage || 'Mensaje de error no disponible'
      }).then(() => {
        window.location.reload();
      });
    });
  };
  

  handleOpcionMenu = (opcion) => {
    this.setState({
      selectedOption: opcion,
      opcionSel: opcion
    });

    if (opcion === 'Copiar de Fact. Cliente') {
      this.copiarDeFacturaCliente();
    }

  };

  abrirModal(codigoBuscar, rowdata) {

    this.setState({
       isModalOpen: true,
       sourceGridCodigos: [],
       searchButtonClicked: true 

    });

    // this.actualizarDatosGrid();
  
    // Imprime todo el objeto 'rowdata' para entender su estructura
  
    // Intenta acceder a 'codigoCliente' de diferentes maneras
    const codigoClienteSeleccionado = codigoBuscar;
  
    // console.log("Código Cliente Seleccionado:", codigoClienteSeleccionado);
    var username = "";
    var password = "";

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);
    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;

      });
    }


    if (token_Data === null) {
      this.props.history.push("");
    }
    this.setState({
			message: '',
			isLoading: true
		});
		const response = fetch(`${dominio}/get_codigosUnificados`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
      body: JSON.stringify({ 
        username,
        password,       
        codigoClienteSeleccionado,
      }),
			});
		
			response
			.then(async (res) => {
				let data = await res.json();
				// console.log(data);
				let temp_Data = [];
				data.forEach((element) => {
					let obj = {
            
						Code: element.Code,
						Name: element.Name,
						U_CodMacizo: element.U_CodMacizo,
						U_DesMacizo: element.U_DesMacizo,
						U_CodCliente: element.U_CodCliente,
						WhsCode: element.WhsCode,
						U_Planta: element.U_Planta,

					};
					temp_Data.push(obj);
				});
				this.setState({
					message: '',
					isLoading: false,
					nuevosDatos: temp_Data,

				});
        this.setState({
          sourceGridCodigos: new jqx.dataAdapter({
            localData: this.state.nuevosDatos,
            dataType: "json",
          }),
        });
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});





  }

  abrirModalLote(codigoBuscarLote, codigoBuscarAlmacen) {
    const codigoLoteSeleccionado2 = codigoBuscarLote;
    const codigoAlmacenSeleccionado = codigoBuscarAlmacen;
    // codigoAlmacenSeleccionado

    // Actualiza el ItemCode de cada objeto en documentLines
const updatedDocumentLines = this.state.DocumentLines.map(line => ({
  ...line,
  ItemCode: codigoLoteSeleccionado2
}));

    this.setState({
       isModalOpenLote: true,
       sourceGridCodigosLotes: [],

    });
    // this.actualizarDatosGrid();
  
    // Imprime todo el objeto 'rowdata' para entender su estructura
  
    // Intenta acceder a 'codigoCliente' de diferentes maneras
    // const codigoLoteSeleccionado = codigoBuscarLote;
  
    // console.log("Código Cliente Seleccionado:", codigoLoteSeleccionado);
    // var username = "";
    // var password = "";

    // let token = localStorage.getItem("token");
    // let token_Data = JSON.parse(token);
    // if (token_Data !== null) {
    //   token_Data.forEach((element) => {
    //     username = element.usuarioSAP;
    //     password = element.contraseñaSAP;

    //   });
    // }


    // if (token_Data === null) {
    //   this.props.history.push("");
    // }
    this.setState({
			message: '',
			isLoading: true
		});

    
		// const response = fetch(`${dominio}/get_codigosLotes`, {
		// 	method: 'POST',
		// 	headers: {
		// 		'Content-Type': 'application/json',
		// 	},
    //   body: JSON.stringify({ 
    //     username,
    //     password,       
    //     codigoLoteSeleccionado,
    //     codigoAlmacenSeleccionado
    //   }),
		// 	});
		
    console.log(codigoLoteSeleccionado2);
    console.log(codigoAlmacenSeleccionado);

  // codigoLoteSeleccionado2 = E1SO14193925
  // codigoAlmacenSeleccionado = E113

    const apiKey = 'jUX3yVGrFuNoZCczhtTb3aSMZrsPHbTbMojPiBoyoUU';
    const url = `http://192.168.0.8:8666/lotes/${codigoLoteSeleccionado2}/${codigoAlmacenSeleccionado}`;
    // const url = `http://192.168.0.8:8666/lotes/V2175610062022/C111`;

    const response = fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'API-Key': apiKey,
      },
    })
    response
			.then(async (res) => {
				let data = await res.json();
				console.log(data);

        let temp_Data = [];
				data.forEach((element) => {
					let obj = {
            
						ItemCode: element.Itemcode,
						lote: element.DistNumber,
						WhsCode: element.Whscode,
						Quantity: element.Quantity,						

					};
					temp_Data.push(obj);
				});
				this.setState({
					message: '',
					isLoading: false,
					nuevosDatosLote: temp_Data,

				});
        this.setState({
          sourceGridCodigosLotes: new jqx.dataAdapter({
            localData: this.state.nuevosDatosLote,
            dataType: "json",
          }),
          DocumentLines: updatedDocumentLines

        });
			
				this.setState({
					message: '',
					isLoading: false,

				});
     
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});





  }

  abrirModalSociosNegocios = () => {


      this.setState({
        // isLoading: true,
        isModalOpenSociosNegocios: true,
        sourceGridCodigosLotes: [],
 
     });
      
      var username = '';
      var password = '';
      let token = localStorage.getItem('token');
      let token_Data = JSON.parse(token);
  
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
        });
      }
  
      if (token_Data === null) {
        this.props.history.push(''); // Ajusta la redirección según tus necesidades
      }
  
      // console.log(token_Data);
  
      const url_sociosNegocios = `${dominio}/get_sociosNegocios`;
      const parametros = `?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;
      
  

    const response = fetch(url_sociosNegocios + parametros, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    response
			.then(async (res) => {
				let data = await res.json();
				console.log(data.data.value);

        let temp_Data = [];
				data.data.value.forEach((element) => {
					let obj = {
            
						CardCode: element.CardCode,
						CardName: element.CardName,

					};
					temp_Data.push(obj);
				});
				this.setState({
					message: '',
					isLoading: false,
					nuevosDatosSociosNegocios: temp_Data,

				});
        this.setState({
          sourceGridCodigosSociosNegocios: new jqx.dataAdapter({
            localData: this.state.nuevosDatosSociosNegocios,
            dataType: "json",
          }),
          // DocumentLines: updatedDocumentLines

        });
			
				this.setState({
					message: '',
					isLoading: false,

				});
     
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});
    }

  LoteSeleccionado(codigoSeleccionadoWhsCode, codigoSeleccionadoWhslote, codigoSeleccionadoWhsQuantity) {
    const codigoLoteSeleccionado3 = codigoSeleccionadoWhsCode;


    // Actualiza el ItemCode de cada objeto en documentLines
const updatedDocumentLines2 = this.state.DocumentLines.map(line => ({
  ...line,

  WarehouseCode: codigoLoteSeleccionado3,
  // BatchNumber: codigoSelectlote,
  // Quantity: codigoSelectQuantity
}));

this.setState({
  DocumentLines: updatedDocumentLines2
  

});

const codigoSelectlote = codigoSeleccionadoWhslote;
const codigoSelectQuantity = codigoSeleccionadoWhsQuantity;


// Actualiza el BatchNumber de cada objeto en documentLines
const updatedDocumentLines = this.state.DocumentLines.map(line => ({
  ...line,
  BatchNumbers: [
    {
      ...line.BatchNumbers[0], // Mantén los otros campos sin cambios
      BatchNumber: codigoSelectlote, // Actualiza el BatchNumber
      Quantity: codigoSelectQuantity
    }
  ]
}));


this.setState({
  DocumentLines: updatedDocumentLines
});

    this.setState({ isModalOpen: false });
    this.setState({ isModalOpenLote: false });

  }


  SocioNegociosSeleccionado(codigoSeleccionadoCardCode, codigoSeleccionadoCardName) {
    const codigoSocioNegocioSeleccionado4 = codigoSeleccionadoCardCode;
    const codigoSocioNegocioSeleccionado5 = codigoSeleccionadoCardName;


this.setState({
  CardCode: codigoSocioNegocioSeleccionado4,
  CardName: codigoSocioNegocioSeleccionado5,
  isModalOpenSociosNegocios: false,
});
  }


  cerrarModal() {
    this.setState({ isModalOpen: false });
  }
  cerrarModalLote() {
    this.setState({ isModalOpenLote: false });
  }

  cerrarModalSociosNegocios= () => {
    this.setState({ isModalOpenSociosNegocios: false });
  }

  handleAgregarLinea = () => {
    const { numRows, sourceGridMacizo, columns } = this.state;
  
    const nuevaLinea = {};
    columns.forEach((column) => {
      nuevaLinea[column.datafield] = "";
    });
  
    const newData = [...sourceGridMacizo.records, nuevaLinea];
  
    const newDataAdapter = new jqx.dataAdapter({
      localData: newData,
      dataType: "json",
    });
  
    this.setState({
      sourceGridMacizo: newDataAdapter,
      numRows: numRows + 1,
    });
  };
  
  handleRowSelect(event) {
    const selectedRows = [...this.state.selectedRows];
    const index = selectedRows.indexOf(event.args.rowindex);
  
    if (index === -1) {
      selectedRows.push(event.args.rowindex);
    } else {
      selectedRows.splice(index, 1);
    }
  
    this.setState({
      selectedRows: selectedRows,
    });
  }

  handleCheckboxChange(row) {
    // Actualiza el estado cuando cambia el estado de la casilla de verificación
    const selectedRows = [...this.state.selectedRows];
    const index = selectedRows.indexOf(row);
  
    if (index === -1) {
      selectedRows.push(row);
    } else {
      selectedRows.splice(index, 1);
    }
  
    this.setState({ selectedRows: selectedRows });
  }

  handleEliminarFilas = () => {
    const { selectedRows, sourceGridMacizo, DocumentLines } = this.state;
  
    // Filtra las líneas a eliminar en base a los índices seleccionados
    const nuevoGridMacizo = sourceGridMacizo.records.filter(
      (_, index) => !selectedRows.includes(index)
    );
  
    // Filtra las líneas a eliminar en base a los índices seleccionados
    const nuevoDocumentLines = DocumentLines.filter(
      (_, index) => !selectedRows.includes(index)
    );
  
    // Actualiza el sourceGridMacizo y DocumentLines, y forza la actualización de la grilla
    this.setState(
      {
        sourceGridMacizo: new jqx.dataAdapter({
          localData: nuevoGridMacizo,
          dataType: "json",
        }),
        DocumentLines: nuevoDocumentLines,
        selectedRows: [],
      },
      () => {
        // Limpia la selección para que los checkboxes se desmarquen
        if (this.myGrid) {
          this.myGrid.clearselection();
          this.myGrid.updatebounddata();
        }
      }
    );
  
    // console.log("Filas eliminadas:", selectedRows);
    // console.log("DocumentLines actualizado:", nuevoDocumentLines);
  };
  
  handleInputChange = (event, index) => {
    const { name, value } = event.target;
    this.setState({
      numeroFactura: event.target.value,
    });
    if (index === undefined) {
      this.setState({ [name]: value });
    } else {
      const documentLines = [...this.state.DocumentLines];
      documentLines[index][name] = value;
      this.setState({ DocumentLines: documentLines });
    }
  };

  handleInputChangeOtro = (event, index) => {
    const { name, value } = event.target;
   
      const documentLines = [...this.state.DocumentLines];
      documentLines[index][name] = value;
      this.setState({ DocumentLines: documentLines });
    
  };

  handleInputChangeComentario = (event, index) => {
    // const { name, value } = event.target;
    this.setState({
      Comments: event.target.value,
    });
  };

  handleBatchNumberChange = (event, lineIndex, batchIndex) => {
    const { name, value } = event.target;
    const documentLines = [...this.state.DocumentLines];
    documentLines[lineIndex].BatchNumbers[batchIndex][name] = value;
    this.setState({ DocumentLines: documentLines });
  };

  addDocumentLine = () => {
    const newDocumentLine = {
      ItemCode: "",
      U_FacNom: "",
      Quantity: "",
      TaxCode: "",
      Price: "",
      PriceAfterVAT: "",
      WarehouseCode: "",
      BatchNumbers: [
        {
          BatchNumber: "",
          Quantity: ""
        },
      ],
    };

    this.setState((prevState) => ({
      DocumentLines: [...prevState.DocumentLines, newDocumentLine],
    }));
  };

  componentDidMount() {

    this.setState({
      isLoading: true,
    });
    
    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push(''); // Ajusta la redirección según tus necesidades
    }

    // console.log(token_Data);

    const url_sociosNegocios = `${dominio}/get_sociosNegocios`;
    const parametros = `?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;
    

    fetch(url_sociosNegocios + parametros, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        // console.log(data.message);
// ------------------------------

if (data.message === "Error en la solicitud") {
  const jsonResponse = JSON.parse(data.data); // Cambia data.message a data.data para obtener el objeto JSON correcto
  
  const errorMessage = jsonResponse && jsonResponse.error && jsonResponse.error.message && jsonResponse.error.message.value;
  // Reemplaza el alert con SweetAlert2
  Swal.fire({
    icon: 'error',
    title: 'No se cargó el listado de socios de negocios, Contacte al administrador',
    text: errorMessage || 'No se cargó el listado de socios de negocios, Contacte al administrador'
  }).then(() => {
    this.setState({ 
      // sociosNegocios: data.data.value,
      isLoading: false
     });
  });
}

else {
 // Almacena los datos de socios de negocios en el estado
 this.setState({ 
  sociosNegocios: data.data.value,
  isLoading: false
 });
}
// ------------------------------
                
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  handleRadioChange = (event) => {
    const selectedOption = event.target.value;

    this.setState({
      selectedOption,
    });
  };

  handleDateChange(date) {
    this.setState({
      DocDate: date,
    });
  }

  handleInputChangeCardName = (event) => {
    // Establece el valor solo cuando el usuario realiza una selección
    const selectedCardCode = event.target.value;

    // Actualiza el estado del CardCode y CardName
    this.setState({
      CardCode: selectedCardCode,
      CardName: this.getCardNameByCode(selectedCardCode),
    });
  };

  getCardNameByCode = (selectedCardCode) => {
    // Busca el CardName correspondiente al CardCode seleccionado
    const selectedSocio = this.state.sociosNegocios.find(
      (socio) => socio.CardCode === selectedCardCode
    );

    return selectedSocio ? selectedSocio.CardName : '';
  };

  handleCrear = async (event) => {

    this.setState({
      isLoading: true,
    });

    event.preventDefault();
    // const token = localStorage.getItem('TOKEN');
    // console.log("TOKEN: ", token);

    try {

      var username = "";
      var password = "";
      let token = localStorage.getItem("token");
      let token_Data = JSON.parse(token);
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
        });
      }


      if (token_Data === null) {
        this.props.history.push("");
      }



      const response = fetch(`${dominio}/postEntregas`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,

          CardCode: this.state.CardCode,
          DocDate: this.state.DocDate,
          Comments: this.state.Comments,
          DocumentLines: this.state.DocumentLines.map((line) => ({
            ItemCode: line.ItemCode,
            Quantity: Number(line.Quantity),
            TaxCode: "IVA",
            Price: 1.5,
            WarehouseCode: line.WarehouseCode,
            PriceAfterVAT: Number(line.PriceAfterVAT),
            BatchNumbers: line.BatchNumbers.map((batch) => ({
              BatchNumber: batch.BatchNumber,
              Quantity: Number(batch.Quantity),
            })),
          })),

        }),

      });


      response
        .then((res) => res.json())
        .then((data) => {
          const jsonResponse = JSON.parse(data.response_text);
          // console.log(jsonResponse);
          // console.log(data);

          if (data.error === "Error en la solicitud") {
            const errorMessage = jsonResponse && jsonResponse.error && jsonResponse.error.message && jsonResponse.error.message.value;

            // Reemplaza el alert con SweetAlert2
            Swal.fire({
              icon: 'error',
              title: 'Error en la solicitud',
              text: errorMessage || 'Mensaje de error no disponible'
            }).then(() => {
              window.location.reload();
            });
          } else {

            this.setState({
              isLoading: false,
            });
            // Reemplaza el alert con SweetAlert2
            Swal.fire({
              icon: 'success',
              title: 'Entrega realizada exitosamente',
              text: 'Número de Documento: ' + jsonResponse.DocNum
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          console.error('Error en la solicitud:', error);
        });
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Verifica si la opción seleccionada es 'Copiar de Fact. Cliente' y el estado ha cambiado
    if (
      this.state.selectedOption === 'Copiar de Fact. Cliente' &&
      this.state.selectedOption !== prevState.selectedOption
    ) {
      // Establece 'factura' como la opción seleccionada
      this.setState({
        selectedOption: 'factura',
      });


    }
  }

  handleSelectChange = (e) => {
    this.setState({ selectedOption: e.target.value });
  };

  handleSelectChangeTienda = (e) => {
    this.setState({ selectedOptionTienda: e.target.value });
  };

}

export default Entrega;
